import { BaseApiResponse } from "../common";
import {
  LatePaymentInterestType,
  PaymentMethodType,
  PaymentTermsType,
} from "../e-invoice-preference";

export class EInvoiceGeneralPreferenceDto {
  Id: number;
  Currency: number | null;
  VatPercent: number | null;
  PaymentTerms: PaymentTermsType | null;
  PaymentMethod: PaymentMethodType | null;
  LatePaymentInterest: LatePaymentInterestType | null;
  IntroductionText: string | null;
  ConclusionText: string | null;
  FooterText: string | null;
  DisplayMessage:boolean;
}

export class EditGeneralPreferenceRequest {
  Id: number;
  Currency: string;
  VatPercent: number | null;
  PaymentTerms: PaymentTermsType | null;
  PaymentMethod: PaymentMethodType | null;
  LatePaymentInterest: LatePaymentInterestType | null;
  IntroductionText: string | null;
  ConclusionText: string | null;
  FooterText: string | null;
  DisplayMessage:boolean;

}

export interface EditGeneralPreferenceResponse
  extends BaseApiResponse<EditGeneralPreferenceError> {
  Preferences: EInvoiceGeneralPreferenceDto | null;
}

export enum EditGeneralPreferenceError {
  NotFound = 1,
}
